<template>
  <div>
    <b-button id="addItens"
              class="btn btn-editar border-0 font-weight-bold pr-4 pl-4"
              @click="$bvModal.show(`${propPagamento.cx_lancamento_id}`)">
      Editar
    </b-button>
  
    <b-modal :id="`${propPagamento.cx_lancamento_id}`"
             centered
             size="lg"
             :title="`Editar Despesa`"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div class="container">
        <div class="col-3 mt-3 mr-5 text-left">
          <b-form-group label="Data de lançamento"
                        label-for="Data de Lançamento"
                        class="mb-0" />
          <b-form-input
            id="Data de Lançamento"
            v-model="despesa.data_lancamento"
            required
            type="date" />
        </div>
        <div class="d-flex mt-1 ml-3">
          <div class="mt-3 mr-5 text-left">
            <span>Beneficiário </span>
            <b-form-input v-model="despesa.beneficiario"
                          class="mt-2 tamanho-input" />
          </div>
          <div class="mt-3 ml-5 text-left">
            <span>Detalhamento </span>
            <b-form-input v-model="despesa.detalhamento"
                          class="mt-2 tamanho-input" />
          </div>
        </div>    
        <div class="d-flex flex-column align-items-start mt-4">
          <span class="ml-3 mb-2">Valor</span>
          <div>
            <b-form-input v-model="despesa.valorTotal"
                          v-money="money"
                          type="text" 
                          class="ml-3 pt-3 pb-3"
                          size="sm"
                          trim />
          </div>
        </div>
      </div>
      <br>
      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal"
                @click="voltar (close)">
          Voltar
        </button>
        <button type="button"
                class="btn btn-secondary ml-2"
                @click="editarPagamento()">
          Salvar
        </button>
      </template>  
    </b-modal>   
  </div>
</template>

<script>
  // Importes
  import moment from 'moment'
  import { VMoney } from 'v-money'

  // Services
  import lancamentoService from '../../lancamentoService'

  export default ({
    name: 'ModalEditarDespesa',
    components: {
    },
    directives: {
      money: VMoney
    },
    props: {
      propPagamento: {type: Object, default: null},
      propAtualizarStatus: {type: Function,  default: null}
    },
    data () {
      return {
        despesa: {
          beneficiario: '',
          detalhamento: '',
          valorTotal: 0,
          data_lancamento: null,
          cx_lancamento_id: null
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    created () {
      this.despesa.beneficiario = this.propPagamento.beneficiario
      this.despesa.detalhamento = this.propPagamento.detalhamento
      this.despesa.data_lancamento = moment(this.propPagamento.data_lancamento, 'YYYY-MM-DD').format('YYYY-MM-DD')
      this.despesa.valorTotal = this.propPagamento.valor_total
      this.despesa.cx_lancamento_id = this.propPagamento.cx_lancamento_id
    },
    methods: {
      voltar (close) {
        close()
      },
      async editarPagamento () {
        await lancamentoService.editarDespesa(this.despesa)
        // Renderiza pedidos atualizados
        this.$store.dispatch('frenteCaixa/atualizarPedidos')

        this.$bvModal.hide(`${this.propPagamento.cx_lancamento_id}`)
      },
    }
  })

</script>

<style scoped>
.icon-add-new {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
    margin-right: 10px;
  }
  #addItens:hover .icon-add-new {
    fill: white;
  }
  .btn-close-modal {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .btn-close-modal:hover {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .parcelas-title {
    font-size: 18px;
  }
  .valor-recebido {
    outline: none;
  }
  .btn-editar {
    background-color:#bcbcbc !important;
    font-size:1.2rem;
    color:black;
  }
  .btn-editar:hover {
    color:white;
  }
  .tamanho-input{
    width: 125%;
  }
</style>